// extracted by mini-css-extract-plugin
module.exports = {"main":"StartIndex_main__4RMv5","search-fade-in":"StartIndex_search-fade-in___zHAA"};